
import { useEffect, useRef } from "react";
import { useState } from "react";
import { Menu, MenuItem, MenuItemWrapper, MenuModal, MenuWrapper } from "../../atoms/Menu";
import MoreIcon from "../../../images/MoreIcon.png";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import * as userAction from "@mywvglobal-shared/mywv-shared/action/userDetailsAction";
import { constants } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { isMobile } from "../../../utilities/deviceUtilities";
import * as WorldActions from "@mywvglobal-shared/mywv-shared/action/worldAction";
import * as NetworkUtilities from "../../../utilities/networkUtilities";
import CommonModalPopup from "../../organism/CommonModalPopup";
import * as Utilites from "@mywvglobal-shared/mywv-shared/common/utilities";
import { gaEvent } from "../../../utilities/analytics";
import moment from "moment/moment";
import "../../../styles/Common.css";
import * as UpdateSupportNotificationAction from "@mywvglobal-shared/mywv-shared/action/updateSupporterContactDetailsNotificationAction";
import * as LogoutAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import { logoutUser } from "../../../utilities/LogOutUtils";
import pcAccountIcon from "../../../images/pc_account_icon.svg";
import pcAccountWhiteIcon from "../../../images/pc_account_white_icon.svg";
import { AccountImg } from "../../atoms/ProjectCelebration";
import { ProfilePic } from "../../atoms/MyAccountView";

const MenuIcon = (props) => {

  const dispatch = useDispatch();
  const { persistItemsReducer } = useSelector((state) => state);
  const { loginReducer } = useSelector((state) => state);
  const { worldReducer } = useSelector((state) => state);
  const { updateSupporterContactDetailsNotificationReducer } = useSelector((state) => state);
  const [showMenu, setShowMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showLogoutPopUp, setShowLogoutPopUp] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [menuId, setMenuId] = useState(null);
  const navigate = useNavigate();
  const [displaynewsfeed, setDisplaynewsfeed] = useState(false);
  const [profileImage, setProfileImage] = useState(worldReducer?.getSponsorChildCoordinates?.supporterProfilePictureURL
    ? worldReducer?.getSponsorChildCoordinates?.appBaseURL
    + worldReducer?.getSponsorChildCoordinates?.supporterProfilePictureURL
    : MoreIcon);
  const menuRef = useRef(null);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleMenu = () => {
    let open = showMenu;
    setShowMenu(!open);
    gaEvent("MoreBtn", persistItemsReducer);
  }

  const getSponsorChildCoordinates = (loginReducer) => {
    dispatch(WorldActions.clearWorldReducer());
    const reqBody = {
      donorID: persistItemsReducer?.sponsorID,
      emailID: persistItemsReducer?.emailID,
      languageCode: persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const baseURL = loginReducer?.getSOConfiguration?.soBaseUrl;
    const requestPayload = {
      baseURL: loginReducer?.getSOConfiguration?.soBaseUrl,
      reqBody,
      reqHeaders: NetworkUtilities.GetNetWorkHeaders(persistItemsReducer),
    };
    if (baseURL) {
      dispatch(WorldActions.getSponsorAndChildCoordinates(requestPayload));
    }
  };

  const handleHideNotification = () => {
    const hasVisited = localStorage.getItem("accountPageVisited") === "true";
    if (hasVisited) {
      getSupporterNotificationServer()
    }
    localStorage.removeItem("accountPageVisited");
  };

  useEffect(() => {
    const response = updateSupporterContactDetailsNotificationReducer?.updateSupporterContactDetailsNotificationResponse;
    if (response?.status?.toLowerCase() === "success") {
      setShowNotification(false);
    }
  }, [updateSupporterContactDetailsNotificationReducer]);

  useEffect(() => {
    if (worldReducer?.getSponsorChildCoordinates?.donorID && worldReducer?.childList?.length === 0 && worldReducer?.getSponsorChildCoordinates?.regions?.length > 0) {
      const worldDataValues = [];
      let localChildList = [];
      const sponsorData = {
        id: worldDataValues.length + 1,
        isSponsor: true,
        latitude: parseFloat(worldReducer?.getSponsorChildCoordinates?.supporterLatitude),
        longitude: parseFloat(worldReducer?.getSponsorChildCoordinates?.supporterLongitude),
        image: worldReducer?.getSponsorChildCoordinates?.supporterProfilePictureURL
      };
      if (worldReducer?.getSponsorChildCoordinates?.supporterEmail) {
        const param = {
          sponsorEmail: worldReducer?.getSponsorChildCoordinates?.supporterEmail,
        };
        dispatch(Action.saveSponsorEmailPersist(param));
      }
      if (sponsorData && sponsorData.latitude && sponsorData.longitude) {
        worldDataValues.push(sponsorData);
      }
      worldReducer?.getSponsorChildCoordinates?.regions?.forEach((regionData) => {
        regionData?.subRegions?.forEach((subRegionsData) => {
          const subRegionWiseData = [];
          subRegionsData?.countries?.forEach((countriesData) => {
            countriesData?.communities?.forEach((communitiesData) => {
              communitiesData?.sponsoredChildren?.forEach((sponsoredChildrenData) => {
                let commLat = countriesData?.countryLatitude;
                let commLong = countriesData?.countryLongitude;
                if (communitiesData?.communityLatitude
                  && communitiesData?.communityLongitude) {
                  commLat = communitiesData?.communityLatitude;
                  commLong = communitiesData?.communityLongitude;
                }
                const childData = {
                  latitude: commLat,
                  longitude: commLong,
                  childDataValues: sponsoredChildrenData,
                  projectName: communitiesData?.projectName,
                  countryName: countriesData?.countryName,
                  communityName: communitiesData?.communityName
                };
                if (sponsoredChildrenData) {
                  sponsoredChildrenData.projectName = communitiesData?.projectName;
                  sponsoredChildrenData.countryName = countriesData?.countryName;
                  localChildList.push(sponsoredChildrenData);
                }
                subRegionWiseData.push(childData);
              });
            });
          });
          if (subRegionWiseData?.length > 1) {
            let childArray = [];
            subRegionWiseData?.forEach((subRegionWiseDataValue) => {
              childArray.push(subRegionWiseDataValue?.childDataValues);
            });
            childArray = childArray.sort((a, b) => {
              const c = new Date(a?.sponsorshipStartDate);
              const d = new Date(b?.sponsorshipStartDate);
              return c - d;
            });
            childArray = childArray.sort((a, b) => {
              const c = new Date(a?.latestUpdateDate);
              const d = new Date(b?.latestUpdateDate);
              return c - d;
            });
            childArray = childArray.sort((a, b) => b.hasUpdate - a.hasUpdate);
            const subRegionWiseFilteredData = {
              id: worldDataValues.length + 1,
              isSponsor: false,
              latitude: parseFloat(subRegionsData?.subRegionLatitude),
              longitude: parseFloat(subRegionsData?.subRegionLongitude),
              childValues: childArray,
              subRegionName: regionData?.regionName,
              childProjectCountry: `${subRegionWiseData[0]?.projectName}, ${subRegionWiseData[0]?.countryName}`,
              countryName: subRegionWiseData[0]?.countryName,
              communityName: subRegionWiseData[0]?.communityName,
            };
            if (subRegionWiseFilteredData && subRegionWiseFilteredData.latitude
              && subRegionWiseFilteredData.longitude) {
              worldDataValues.push(subRegionWiseFilteredData);
            }
          } else {
            const subRegionWiseFilteredData = {
              id: worldDataValues.length + 1,
              isSponsor: false,
              latitude: parseFloat(subRegionWiseData[0]?.latitude),
              longitude: parseFloat(subRegionWiseData[0]?.longitude),
              childValues: subRegionWiseData[0]?.childDataValues,
              childProjectCountry: `${subRegionWiseData[0]?.projectName}, ${subRegionWiseData[0]?.countryName}`,
              communityName: subRegionWiseData[0]?.communityName,
              countryName: subRegionWiseData[0]?.countryName,
            };
            if (subRegionWiseFilteredData && subRegionWiseFilteredData.latitude
              && subRegionWiseFilteredData.longitude) {
              worldDataValues.push(subRegionWiseFilteredData);
            }
          }
        });
      });
      if (worldDataValues && worldDataValues.length > 0) {
        worldDataValues.sort((item1, item2) => item1.latitude - item2.latitude);
        worldDataValues.sort((item1, item2) => item1.longitude - item2.longitude);
        if (localChildList && localChildList.length > 0) {
          localChildList = localChildList.sort((a, b) => {
            const c = new Date(a?.sponsorshipStartDate);
            const d = new Date(b?.sponsorshipStartDate);
            return c - d;
          });
          localChildList = localChildList.sort((a, b) => {
            const c = new Date(a?.latestUpdateDate);
            const d = new Date(b?.latestUpdateDate);
            return c - d;
          });
          localChildList = localChildList.sort((a, b) => b.hasUpdate - a.hasUpdate);
          const param = {
            childList: localChildList,
          };
          dispatch(WorldActions.saveChildList(param));
        }
      }
    }
  }, [worldReducer?.getSponsorChildCoordinates?.donorID]);

  useEffect(() => {
    getSponsorChildCoordinates(loginReducer);
  }, [loginReducer]);

  useEffect(() => {
    if (Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "StoriesInBottomNavBar",
      "",
    )) {
      setDisplaynewsfeed(true)
    }
  }, [loginReducer?.getSOConfiguration]);

  useEffect(() => {
    if (worldReducer?.getSponsorChildCoordinates && worldReducer?.getSponsorChildCoordinates?.responseSource === null) {
      if (!worldReducer.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp) {
        setShowNotification(true);
      } else {
        let currentDate = moment();
        let notificationDate = moment(worldReducer?.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp);
        let diff = currentDate.diff(notificationDate, "days");
        if (diff > 365) setShowNotification(true);
      }
    }
  }, [worldReducer]);

  useEffect(() => {
    setProfileImage(worldReducer?.getSponsorChildCoordinates?.supporterProfilePictureURL
      ? worldReducer?.getSponsorChildCoordinates?.appBaseURL
      + worldReducer?.getSponsorChildCoordinates?.supporterProfilePictureURL
      : MoreIcon);
  }, [worldReducer?.getSponsorChildCoordinates]);

  async function handleUnauthorizedTokenError() {
    await logoutUser({
      persistItemsReducer, loginReducer, dispatch,
      LogoutAction, constants,
    });
  }

  useEffect(() => {
    // if token is expired or unauthorized, logout user
    if (worldReducer.errorMessage?.status === 401) {
      handleUnauthorizedTokenError()
      return
    }
  }, [worldReducer?.errorMessage?.status]);

  const getSupporterNotificationServer = async () => {
    dispatch(userAction.clearUserDetailsReducer());
    dispatch(userAction.showUserDetailsReducer());
    const reqBody = {
      donorID: persistItemsReducer?.sponsorID,
      lastShownNotificationDateTime: moment().format()
    };
    let url = loginReducer?.getSOConfiguration?.soBaseUrl;
    const requestPayload = {
      baseURL: url,
      reqBody,
      reqHeaders: NetworkUtilities.GetNetWorkHeaders(persistItemsReducer)
    };
    dispatch(UpdateSupportNotificationAction.updateSupporterContactDetailsNotificationRequest(requestPayload));
  };

  const executeLogOut = async () => {
    handleHideNotification()
    let id_token = persistItemsReducer?.saveAuthParams?.id_token;
    await delay(100);
    setShowMenu(false);
    if (!worldReducer.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp) {
      getSupporterNotificationServer();
    }
    const logoutUrl = constants?.postLogoutUrl + persistItemsReducer?.selectedSOData?.soCode?.toLowerCase();
    dispatch(Action.logoutPersist(persistItemsReducer));
    if (window.location.href.includes("/communityhomeview") ||
      window.location.href.includes("/connect") ||
      window.location.href.includes("/sendAGift")) {
      dispatch(Action.logoutReset());
    }
    if (loginReducer?.getSOConfiguration?.loginModule?.provider == "Auth0") {
      if (persistItemsReducer?.selectedSOData?.soCode?.toLowerCase() == "nzlo") {
        /* This code will remove session cookie and clear the cuurent active session. Redirection will be to the external site. */
        var d = new Date();
        d.setTime(d.getTime());
        const expires = "expires=" + d.toUTCString();
        document.cookie = constants?.so_NZLO?.nzSSOCookieName + "=" + "" + ";domain=worldvision.org.nz;path=/;" + expires;
        window.location.replace("https://" + loginReducer?.getSOConfiguration?.loginModule?.domainName + "/v2/logout?federated=true&returnTo=" + encodeURI(constants?.so_NZLO?.app_url));
      } else {
        window.location.replace(logoutUrl);
      }
    } else if (loginReducer?.getSOConfiguration?.loginModule?.provider == "OneLogin") {
      window.location.replace(loginReducer?.getSOConfiguration?.loginModule?.domainName + "/logout?post_logout_redirect_uri=" + logoutUrl + "&id_token_hint=" + id_token);
    }
    localStorage.removeItem("tokenResp");
    localStorage.removeItem("persist:root");
    localStorage.removeItem("ssoCompleted");
  }

  const openMenuItem = () => {
    if (menuId) {
      if (menuId === 1) {
        navigate("/myaccount", { state: { childcode: props?.selectedChild, navigateFrom: props?.navigateFrom } });
        setMenuId(null);
      }
    }
  }

  const closeOpenMenus = (e) => {
    if (menuRef.current && showMenu && !menuRef.current.contains(e.target)) {
      setShowMenu(false);
    }
  }

  useEffect(() => {
    window.addEventListener("mousedown", closeOpenMenus);
  })

  const handleMenuItem = (menuId) => {
    setMenuId(menuId);
    setOpenModal(true);
    setShowMenu(false);
    gaEvent("Accounts&Settings", persistItemsReducer)
  }

  const handleMapClick = () => {
    navigate("/home");
    gaEvent("MapBtn", persistItemsReducer)
  }

  return (
    <>
      <MenuWrapper communityStation header={props?.header} station={props?.station} pc={props?.pc} ref={menuRef}>
        <Menu onClick={handleMenu}>
          {showNotification && <div className="circleupdate" style={{ bottom: props?.pc ? "25px" : "23px", right: props?.pc ? "5px" : "-4px" }}>{1}</div>}
          {window.location.href.includes("project-celebration") ? <AccountImg src={isMobile() ? pcAccountWhiteIcon : pcAccountIcon} alt="" ></AccountImg>
            :
            <ProfilePic src={profileImage} alt={t("ProfileImage")} style={{ width: "38px", height: "38px", aspectRatio: "480/640" }} />
          }
        </Menu>
        {showMenu &&
          <MenuItemWrapper>
            {isMobile() && props?.worldmenu ? null : <MenuItem onClick={() => { handleMenuItem(1) }}>{t("AccountSetting")}</MenuItem>}
            {isMobile() ? <MenuItem onClick={() => { handleMapClick() }}>{t("MapView")}</MenuItem> : null}
            {isMobile() && !displaynewsfeed && !props?.worldmenu ? <MenuItem onClick={() => { navigate("/newsandstories", { state: { childcode: props?.selectedChild } }) }}>{t("Newsfeed")}</MenuItem> : null}
            <MenuItem
              onClick={() => { handleMenu(); setShowLogoutPopUp(true); gaEvent("LogOut", persistItemsReducer) }}
            >{t("DT_WVM_ACC_HEAD_00010_LogOut")}
            </MenuItem>
          </MenuItemWrapper>}
      </MenuWrapper>
      <MenuModal>
        {openModal && openMenuItem()}
      </MenuModal>
      {showLogoutPopUp && <CommonModalPopup
        logout
        type="warning"
        show={true}
        title={t("Warning")}
        body={t("ConfirmLogoutMessage")}
        confirm={{ title: t("Yes"), handler: () => { executeLogOut(); setShowLogoutPopUp(false); gaEvent("LogoutPopupYesBtn", persistItemsReducer) } }}
        close={{ handler: () => { setShowLogoutPopUp(false); gaEvent("LogoutPopupCloseBtn", persistItemsReducer) } }}
        cancel={{ title: t("No"), handler: () => { setShowLogoutPopUp(false); gaEvent("LogoutPopupNoBtn", persistItemsReducer) } }}
      />}
    </>
  )
}

export default MenuIcon;